import { Component, ViewEncapsulation, OnInit, ViewChild,EventEmitter,Input,Output,TemplateRef,AfterContentInit,QueryList,ContentChildren,
  Compiler, ComponentRef, Injector, NgModule, NgModuleRef, ViewContainerRef, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../services/utility-service/utility-service';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Router,ActivatedRoute } from '@angular/router';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { SectionBuilderService } from '../services/sectionbuilder-services/sectionbuilder';
import { AppService } from '../app.service';
import {StandardUIService} from '../services/standardui-service/standardui-service';
import { SystemobjectsService } from '../services/objectservice/systemobjects.service';
import { FormBuilder, FormsModule,ReactiveFormsModule} from '@angular/forms';
// import { PageBuilderService } from '../services/page-builder/page-builder.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ReportViewModuleModule } from '../report-view-module/report-view-module.module';
import { TabViewModuleModule } from '../tab-view-module/tab-view-module.module';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { MetaData } from '../services/metadata/metadata.service';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import { TrackingViewModuleModule } from '../tracking-view-module/tracking-view-module.module';
import { BabyStatusConditionsModule } from '../baby-status-conditions/baby-status-conditions.module';
import { ProgressBarModule } from '../progress-bar/app-progress-bar.module';
import { NoteModuleModule } from '../note-module/note-module.module';
import { QueryBuilderViewModuleModule } from '../query-builder-module/query-builder-view-module.module';
import { AttachmentsViewModuleModule } from '../attachments/attachments-view-module/attachments-view-module.module';
import { FroalaEditorModule } from 'angular-froala-wysiwyg';

@Component({
 selector: 'app-tab-view',
 templateUrl: './tab-view.component.html',
 styleUrls: [],
 encapsulation: ViewEncapsulation.None
})

export class TabViewComponent implements OnInit {
 brodCastChange: BehaviorSubject<any> = new BehaviorSubject(null);
 step_form:any;
 @ViewChild('modalBody', {read: ViewContainerRef}) modalBody: ViewContainerRef;

 private cmpRef: ComponentRef<any>;

 loading = false;
 components = [];
 @Output() loadcomplete = new EventEmitter<any>();
 @Output() componentSelection = new EventEmitter<any>();

 dataFromDynamicComponent;

 // Static cache for compiled dynamic component factories
 private static templateFactoryCache = new Map<string, any>();

 constructor(
     private agentscriptService:AgentscriptService,
     private sectionBuilderService:SectionBuilderService,
     private appService: AppService,
     private utilityService: UtilityService,
     private compiler: Compiler,
     private injector: Injector,
     private route: ActivatedRoute,
     private router: Router,
     private moduleRef: NgModuleRef<any>,
     private objService: SystemobjectsService,
     private standardService:StandardUIService,
     private formBuilder: FormBuilder,
     //public activeModal: NgbActiveModal,
    //  private pageBuilderService: PageBuilderService,
     private spinnerService: SpinnerVisibilityService,
     private metadata:MetaData,
     private objcontroller:ObjectController,
     private cdr: ChangeDetectorRef
 ) {

 }
 @Input() tabData;
 @Input() objectDatas;
 @Input() context;
 objectData:any;
 objectMetaData:any;
 loadingPrev:boolean = false;
 clearsetTimeout: any[]=[];
 private subscriptions: Subscription[] = [];
 ngOnInit() {
     //console.log('Tab Object Data',this.standardService.getObjectData());
     //console.log('Tab Object Meta Data',this.standardService.getObjectMetaData());
     //this.loadingPrev = true;
     //this.objectMetaData = this.standardService.getObjectMetaData();
     //this.dataFromDynamicComponent = this.objectData = this.standardService.getObjectData();
  //    if(this.context.id){
  //         this.objcontroller.getObjectData(this.context.id,this.context.entityName).subscribe((data:any)=>{
  //             this.dataFromDynamicComponent = this.objectData = data;
  //             //this.standardService.setObjectData(data);
  //         })
  //     }
      this.loading = true;
      this.dataFromDynamicComponent = this.context;
      // this.metadata.getObjectMetaData(this.context.entityName).subscribe((data:any)=>{
      //     //this.standardService.setObjectMetaData(data);
      //     this.objectMetaData = data;
      // })

      if(this.tabData){ 
        //console.log("tabdata",this.tabData);  
        let httpArray=[];
        for(let i=0;i<this.tabData.repeatedList.length;i++){       
          httpArray.push(this.sectionBuilderService.getSectionDetail(this.tabData.repeatedList[i].id));                  
        } 
        //console.log(httpArray);
        //return false;
        this.subscriptions.push(forkJoin(httpArray).subscribe((x:any)=>{
          //// console.log('section details',x);
          for(let i=0;i<x.length;i++){  
            this.tabData.repeatedList[i] = x[i];                                
          }
         // console.log('tablist',this.tabData);
          if(this.tabData.isAccordion){
            // this.renderAccordionHtml(this.tabData);
            this.renderAccordionHtml(this.escapeJsonRecursively(this.tabData));
          }else{
            // this.renderTabHtml(this.tabData);
            this.renderTabHtml(this.escapeJsonRecursively(this.tabData));
          }   
          //this.loadCompleted({"contentLoaded":true});                         
        }));           
                  
    }

    // if(this.tabData){ 
    //    // console.log("tabdata",this.tabData);  
    //     if(this.tabData.isAccordion){
    //      // console.log(this.tabData);
    //       this.renderAccordionHtml(this.escapeJsonRecursively(this.tabData));
    //       // this.renderAccordionHtml(this.tabData);
    //     }else{
    //       this.renderTabHtml(this.escapeJsonRecursively(this.tabData));
    //       // this.renderTabHtml(this.tabData)
    //     }
    // }
    
 }
 escapeJsonRecursively(obj: any): any {
  if (Array.isArray(obj)) {
      return obj.map(item => this.escapeJsonRecursively(item)); // Recursively handle arrays
  } else if (typeof obj === 'object' && obj !== null) {
      let escapedObj: Record<string, any> = {}; // Ensure correct object type
      for (let key in obj) {
          escapedObj[key] = this.escapeJsonRecursively(obj[key]); // Recursively escape values
      }
      return escapedObj;
  } else if (typeof obj === 'string') {
      return this.escapeJsonString(obj); // Escape only string values
  }
  return obj; // Return numbers, booleans, null, etc., as-is
}
escapeJsonString(json: string): string {
  return json
  .replace(/</g, "\\u003C")
  .replace(/>/g, "\\u003E")
  .replace(/'/g, "\&#39;") // Escape single quotes
  .replace(/"/g, '\\"'); // Escape double quotes

  // .replace(/\\/g, '\\\\')  // Escape backslashes
  // .replace(/"/g, '&quot;')  // Escape double quotes for HTML attributes
  // .replace(/'/g, '&#39;')   // Escape single quotes safely for HTML
  // .replace(/{/g, '{{ "{" }}')  // Escape curly braces for Angular
  // .replace(/}/g, '{{ "}" }}'); // Escape curly braces for Angular
}
 renderTabHtml(data){
   // console.log(data);
    let output:string = '';
    if(data.repeatedList.length > 1){
        let activeClass:string;
        let tabactiveClass:string;
        let sectionicon:string = '';
        output += '<ul data-tabheadingid="'+data.id+'" role="tablist" class="nav nav-tabs justify-content-start">';
        for(let i in data.repeatedList){
            activeClass = (i == '0') ? "active" : "";
            sectionicon = (data.repeatedList[i].sectioniconurl) ? '<img class="section-icon" src="'+data.repeatedList[i].sectioniconurl+'" style="width:15px;">' : '';
           // console.log(data.repeatedList[i].label,data.repeatedList[i].sectionlabel);
            if(sectionicon+data.repeatedList[i].sectionlabel && data.repeatedList[i].sectionlabel != null){
              output += '<li data-elementid="'+data.repeatedList[i].id+'" class="nav-item"><a (click)="tabToggle($event)"  class="nav-link '+activeClass+'" role="tab" data-tabtitleid="s-'+data.repeatedList[i].id+'" href="javascript:;">'+sectionicon+data.repeatedList[i].sectionlabel+'</a></li>';  
            }else{
              output += '<li data-elementid="'+data.repeatedList[i].id+'" class="nav-item"><a (click)="tabToggle($event)" class="nav-link '+activeClass+'" role="tab" data-tabtitleid="s-'+data.repeatedList[i].id+'" href="javascript:;">'+sectionicon+data.repeatedList[i].label+'</a></li>';
            }            
        }
        output += '</ul>';
        output += '<div data-tabcontentid="'+data.id+'" class="tab-content '+data.label.replace('/','')+'">';
        //// console.log(JSON.stringify(data))
        for(let j in data.repeatedList){
            tabactiveClass = (j == '0') ? "active" : "";
            output += '<div data-elementid="'+data.repeatedList[j].id+'" role="tabpanel" data-panelid="s-'+data.repeatedList[j].id+'" class="tab-pane '+tabactiveClass+'">';
            output += this.standardService.renderHtml(data.repeatedList[j].rowsitems,data.repeatedList[j],this.context);
            output += '</div>';
        }
        output += '</div>';
    }else{
        output += '<div class="e-accordion '+data.label.replace('/','')+'">';
        for(let i in data.repeatedList){
          let sectionicon = (data.repeatedList[i].sectioniconurl) ? '<img class="section-icon" src="'+data.repeatedList[i].sectioniconurl+'" style="width:15px;">' : '<i class="bi bi-card-text"></i> ';
          output += "<div class='e-acrdn-item' [attr.data-elementid]='"+data.id+"'>";
          output += "<div class='e-acrdn-header cursor' [attr.data-tabtitleid]='"+data.repeatedList[i].id+"'>";
            output += "<div class='e-acrdn-header-content'>";
              if(data.repeatedList[i].sectionlabel != null){
                output += "<div class='c-themcolor bold f-16'>"+sectionicon+data.repeatedList[i].sectionlabel+"</div>";
              }else{
                output += "<div class='c-themcolor bold f-16'>"+sectionicon+data.repeatedList[i].label+"</div>";
              }
              
            output += "</div>";

          output += "</div>";
          output += "<div class='e-acrdn-panel' [attr.data-panelid]='"+data.repeatedList[i].id+"'>";
            output += "<div class='e-acrdn-content'>";
              output += this.standardService.renderHtml(data.repeatedList[i].rowsitems,data.repeatedList[i],this.context);
            output += "</div>";
          output += "</div>";
        output += "</div>";
        }
        output += '</div>';
    }
    this.loading = false;
    this.clearsetTimeout.push(setTimeout(() => {
     // console.log(output)
        this.createComponentFromRaw(output);
    }, 100));
   }
 renderAccordionHtml(data){
   // console.log(data);

    let output:string = '';
     if(data.repeatedList){
        if(data.isAccordionHideAll){
          output += "<div class='e-accordion hideall'>";
      }else{
          output += "<div class='e-accordion'>";
      }
      for(let i = 0;i<data.repeatedList.length;i++){
        let sectionicon = (data.repeatedList[i].sectioniconurl) ? '<img class="section-icon" src="'+data.repeatedList[i].sectioniconurl+'" style="width:15px;">' : '<i class="bi bi-card-text"></i> ';
        output += "<div class='e-acrdn-item' [attr.data-elementid]='"+data.id+"'>";
          output += "<div class='e-acrdn-header cursor' [attr.data-tabtitleid]='"+data.repeatedList[i].id+"' (click)='accordionToggle($event)'>";
            output += "<div class='e-acrdn-header-content'>";
              //output += "<div class='c-themcolor bold f-16'>"+(data.repeatedList[i].sectionlabel != null) ? sectionicon+data.repeatedList[i].sectionlabel : sectionicon+data.repeatedList[i].label+"</div>";
              if(data.repeatedList[i].sectionlabel != null){
                output += "<div class='c-themcolor bold f-16'>"+sectionicon+data.repeatedList[i].sectionlabel+"</div>";
              }else{
                output += "<div class='c-themcolor bold f-16'>"+sectionicon+data.repeatedList[i].label+"</div>";
              }
            output += "</div>";
            output += "<div class='e-toggle-icon'>";
              output += "<span class='e-tgl-collapse-icon e-icons'></span>";
            output += "</div>";
          output += "</div>";
          output += "<div class='e-acrdn-panel' [attr.data-panelid]='"+data.repeatedList[i].id+"'>";
            output += "<div class='e-acrdn-content'>";
              output += this.standardService.renderHtml(data.repeatedList[i].rowsitems,data.repeatedList[i],this.context);
            output += "</div>";
          output += "</div>";
        output += "</div>";
      }
      output += "</div>";
    }
    //console.log(output);
    this.loading = false;

    this.clearsetTimeout.push(setTimeout(() => {
      this.createComponentFromRaw(output);
    }, 100));
 }
 public loadCompleted(componentData: object) {
  //console.log(componentData);
  //this._parent.loadingPrev = false;
  this.loadcomplete.emit(componentData);
}
 randomId(){
     return Math.floor(Math.random()*(999-100+1)+100)+Date.now();
 }
 // Here we create the component.
 private createComponentFromRaw(template: string) {
  // Let's say your template looks like `<h2><some-component [data]="data"></some-component>`
  // As you see, it has an (existing) angular component `some-component` and it injects it [data]
  // Now we create a new component. It has that template, and we can even give it data.
    let factory: any;
    if (TabViewComponent.templateFactoryCache.has(template)) {
      factory = TabViewComponent.templateFactoryCache.get(template);
    } else {
      @Component({
        template: template,
        styleUrls: []
      })
      class DynamicComponent implements OnInit {

        constructor(
            private agentScrService:AgentscriptService,
            public _parent: TabViewComponent,
            public spinner:SpinnerVisibilityService
            )
        { }

        rule_trigger = [];
        rule_condition = [];
        rule_then = [];
        rule_else = [];
        currentPage:any;
        pageRules = [];
        gotopage:boolean=false;
        viewed_pages = [];
        public checkFields: Object = { text: 'option_label', value: 'option_value' };
        public checkWaterMark: string = '--Select-- ';
        public popHeight: string = '350px';
        public mode = 'CheckBox';
        public filterPlaceholder = 'Search';
        disableValue = true;
        ngOnInit(){
          //console.log(template);
        }
        ngAfterViewInit(){
            this.loadCompleted({"contentLoaded":true});
            //this.accordionObj.refresh();
        }
        public componentSelectionEmitter(componentData: object) {
            //console.log(componentData);
            this._parent.componentSelection.emit(componentData);
            //this._parent.loadcomplete.emit({"contentLoaded":true});
        }
        public loadCompleted(componentData: object) {
            //console.log(componentData);
            //this._parent.loadingPrev = false;
            this._parent.loadcomplete.emit(componentData);
        }
        buttonAction(e,action){
          if(action){
            let componentData = {
              id: '',
              name: 'New '+action+'-'+this._parent.dataFromDynamicComponent.id,
              roleId:'',
              type:'object',
              entityName:action,
              personid:this._parent.dataFromDynamicComponent.id
            }
            this._parent.componentSelection.emit(componentData);
          }
         }
         accordionToggle(e){
          let elementid:any = $(e.target).parents('[data-elementid]').data('elementid');
          let titleid:any = $(e.target).parents('.e-acrdn-header').data('tabtitleid');
          $("[data-tabtitleid='"+titleid+"'] .e-icons").toggleClass('e-expand-icon');
          $("[data-panelid='"+titleid+"']").slideToggle();
         }
         tabToggle(e){       
           let elementid: any = $(e.target).parents('.smart-controls').data('elementid');
           let titleid: any = $(e.target).data('tabtitleid');
           $(".pane:visible [data-tabheadingid='" + elementid + "'] li a").removeClass('active');
           $(".pane:visible [data-tabcontentid='" + elementid + "'] [data-panelid]").removeClass('active');
           $(e.target).addClass('active');
           $(".pane:visible [data-panelid='" + titleid + "']").find('[data-tabheadingid] li').eq(0).find('a').trigger('click');
           $(".pane:visible [data-panelid='" + titleid + "']").addClass('active');
           //alert($("[data-panelid='" + titleid + "']").find('[data-tabheadingid] li:visible').attr('data-elementid'));
          //  if (!$(".pane:visible [data-panelid='" + titleid + "']").find('[data-tabheadingid] li:visible').eq(0).find('a.nav-link').hasClass('active')) {
          //      $(".pane:visible [data-panelid='" + titleid + "']").find('[data-tabheadingid] li:visible').find('a').trigger('click');
          //  }          
         }
      }
      // Now, also create a dynamic module.
      @NgModule({
        imports: [
            //CommonModule,
            /* BrowserModule removed to avoid duplicate heavy import in dynamic context */
           // FormsModule,
           // ReactiveFormsModule,
            NgbModule,
            ReportViewModuleModule,
            TabViewModuleModule,
            TrackingViewModuleModule,
            //BabyStatusConditionsModule,
            //ProgressBarModule,
            QueryBuilderViewModuleModule,
            AttachmentsViewModuleModule,
            NoteModuleModule,
            //FroalaEditorModule.forRoot(),
          ],
        declarations: [DynamicComponent]
        //providers: []  //- e.g. if your dynamic component needs any service, provide it here.
      })class dynamicModule { };

      // Now compile this module and component, and inject it into that #modalBody in your current component template.
      const mod = this.compiler.compileModuleAndAllComponentsSync(dynamicModule);
      factory = mod.componentFactories.find((comp) =>
          comp.componentType === DynamicComponent
      );
      TabViewComponent.templateFactoryCache.set(template, factory);
      // Cap cache to a reasonable size to prevent memory growth
      if (TabViewComponent.templateFactoryCache.size > 20) {
        const firstKey = TabViewComponent.templateFactoryCache.keys().next().value;
        TabViewComponent.templateFactoryCache.delete(firstKey);
      }
    }
    this.cmpRef = this.modalBody.createComponent(factory);

    // Push the component so that we can keep track of which components are created
    this.components.push(this.cmpRef);

 }

 // Cleanup properly. You can add more cleanup-related stuff here.
 ngOnDestroy() {
     if(this.cmpRef) {
          this.cmpRef.destroy();
     }
     this.clearsetTimeout.forEach(clr => clearTimeout(clr));
     // Destroy any other dynamically created components
     if (this.components && this.components.length) {
       this.components.forEach((c:any) => {
         try { c.destroy(); } catch {}
       });
       this.components = [];
     }
     // Unsubscribe from all subscriptions
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.subscriptions = [];  
 }


}
